<div class="page">

  <div class="page-header">
    <h1>Troubleshooting</h1>
    <p>If you're having trouble logging in or something doesn't look right, clearing your cache and cookies usually fixes it in seconds.</p>
  </div>

  <!-- What & Why -->
  <div class="card">
    <div class="card-header">What &amp; Why</div>

    <div class="info-row">
      <div class="info-icon">🗂️</div>
      <div>
        <h3>What is a cache?</h3>
        <p>Your browser saves copies of website files to help pages load faster. Sometimes those saved files become outdated and conflict with the latest version of SingSnap, causing display issues or login problems.</p>
      </div>
    </div>

    <div class="info-row">
      <div class="info-icon">🍪</div>
      <div>
        <h3>What are cookies?</h3>
        <p>Cookies store small pieces of data like your login session. If a session cookie becomes expired or corrupted, you may be stuck in a login loop or see unexpected errors.</p>
      </div>
    </div>

    <div class="info-row">
      <div class="info-icon">🔒</div>
      <div>
        <h3>Is it safe?</h3>
        <p>Yes. This only clears SingSnap data stored in your browser. Your account, recordings, and other websites are completely unaffected — browsers keep each site's data separate.</p>
      </div>
    </div>
  </div>

  <!-- What gets cleared -->
<div class="card">
  <div class="card-header">What will be cleared</div>

  <div class="clear-item">
    <span>🗑️</span>
    SingSnap app data &amp; local storage
  </div>
  <div class="clear-item">
    <span>🗑️</span>
    SingSnap session cookies
  </div>
  <div class="clear-item">
    <span>🗑️</span>
    SingSnap cached scripts &amp; app files
  </div>
  <div class="clear-item">
    <span>🗑️</span>
    SingSnap service worker data
  </div>
  <div class="clear-item no">
    <span>🔒</span>
    Your SingSnap account &amp; recordings <em>— never affected</em>
  </div>
  <div class="clear-item no">
    <span>🔒</span>
    Other websites' data <em>— browsers keep sites separate</em>
  </div>
</div>

  <!-- CTA -->
  <div class="cta-card">
    <p>Click the button below to clear your SingSnap cache and cookies. You'll be taken to the login page automatically when done.</p>

    <button
      class="fix-btn"
      [class.running]="isRunning"
      [class.done]="isDone"
      [disabled]="isRunning || isDone"
      (click)="runClearAndRedirect()"
    >
      <span>{{ isDone ? '✓' : isRunning ? '⏳' : '🧹' }}</span>
      <span>{{ isDone ? 'All clear! Taking you to login...' : isRunning ? 'Clearing...' : 'Clear Cache &amp; Cookies' }}</span>
    </button>

    <p class="cta-note">Takes less than 5 seconds</p>
  </div>

  <!-- Progress steps -->
  <div class="progress-card" *ngIf="isRunning || isDone">
    <div class="progress-item" [class.complete]="steps.storage" [class.active]="isRunning && !steps.storage">
      <div class="progress-dot">✓</div>
      Clearing local storage &amp; session data
    </div>
    <div class="progress-item" [class.complete]="steps.cookies" [class.active]="steps.storage && !steps.cookies">
      <div class="progress-dot">✓</div>
      Removing SingSnap cookies
    </div>
    <div class="progress-item" [class.complete]="steps.caches" [class.active]="steps.cookies && !steps.caches">
      <div class="progress-dot">✓</div>
      Clearing app cache &amp; service workers
    </div>
    <div class="progress-item" [class.complete]="steps.redirect" [class.active]="steps.caches && !steps.redirect">
      <div class="progress-dot">✓</div>
      Redirecting to login
    </div>
  </div>

  <!-- Footer -->
  <div class="page-footer">
    <p>Still having trouble? <a href="mailto:support@singsnap.com">Contact Support</a></p>
    <a class="back-link" [routerLink]="'/main/home'">← Exit to Home</a>
  </div>

</div>
